import { CacheUtility } from '@utility/cache';
import { CommonUtility } from '@utility/common';
import { APIPath } from '../constants/api';
import { BaseService } from './base';
import { CRUDService } from './crud';

class Components extends CRUDService {
  constructor() {
    super(APIPath.components);
  }

  async items(componentId, forceRefresh = false) {
    const url = `${APIPath.components}/${componentId}/items`;
    const cache = CacheUtility.get(url);
    if (cache && !forceRefresh) {
      return cache;
    }
    const result = await BaseService.get(url);
    CacheUtility.save(url, result);
    return result;
  }

  memo(componentId, data) {
    return BaseService.put(`${APIPath.components}/${componentId}/memo`, data);
  }

  saveItems(componentId, data) {
    return BaseService.put(`${APIPath.components}/${componentId}/items`, data);
  }

  uploadImage = (componentId, reqData) =>
    BaseService.post(`${APIPath.components}/${componentId}/images`, reqData);

  removeImage = (id, imageId) =>
    BaseService.remove(`${APIPath.components}/${id}/images/${imageId}`);

  getLogs(componentId) {
    return BaseService.get(`${APIPath.components}/${componentId}/logs`);
  }

  supplierWise(supplierId, params) {
    if (params) {
      const query = CommonUtility.objectToParams(params);
      const url = `${APIPath.supplierComponents}/${supplierId}?${query}`;
      return BaseService.get(url);
    }
    return BaseService.get(`${APIPath.supplierComponents}/${supplierId}`);
  }

  supplierComponents(supplierId, reqData) {
    return BaseService.put(
      `${APIPath.supplierComponents}/${supplierId}`,
      reqData,
    );
  }

  attributes(componentId) {
    return BaseService.get(`${APIPath.components}/${componentId}/attributes`);
  }

  updateAttributes(componentId, data) {
    return BaseService.put(
      `${APIPath.components}/${componentId}/attributes`,
      data,
    );
  }

  itemAliasMarkPrimary = (componentId, alias, obj) => {
    const encoded = encodeURIComponent(alias);
    return BaseService.put(
      `${APIPath.components}/${componentId}/attributes/${encoded}/primary`,
      obj,
    );
  };

  deleteAttribute(componentId, alias) {
    const encoded = encodeURIComponent(alias);
    return BaseService.remove(
      `${APIPath.components}/${componentId}/attributes/${encoded}`,
    );
  }

  fetchComponentsMetadata() {
    return BaseService.get(APIPath.componentsMetadata);
  }

  globalComponents = params => {
    const query = CommonUtility.objectToParams(params);
    const url = `${APIPath.componentsGlobal}?${query}`;
    return BaseService.get(url);
  };

  globalComponentsUpdate = data =>
    BaseService.put(APIPath.componentsGlobalUpdate, data);
}

const ComponentsService = new Components();
Object.freeze(ComponentsService);
export { ComponentsService };
